export function ErrorComponent(): null {
    return null;
}
